export const noAffiliatesMessage =
  'There are no Affiliates assigned to this Global Company. Please select another Global Company.';
export const noGlobalCustomersMessage =
  'All of your Global Companies are currently enrolled in Swift+';
